import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class ModalRouteService {
  constructor(private router: Router) {}

  openModal(route: string, queryParams?: any) {
    this.router.navigate(["/", { outlets: { modal: route } }], { queryParams });
  }
  closeModal() {
    this.router.navigate(["/", { outlets: { modal: null } }]);
  }
  changeModalParams(activatedRoute, queryParams: any) {
    // TODO can i use router.url so i dont have to pass in activate route?
    this.router.navigate([], {
      relativeTo: activatedRoute,
      queryParams,
      queryParamsHandling: "merge",
    });
  }
  navigate(route: string, queryParams?: any) {
    this.router.navigate(["/", { outlets: { modal: route } }], {
      queryParams: queryParams || {},
      queryParamsHandling: "merge",
    });
  }
}
